import SwishError from './SwishError';

export default class AvailabilityError extends SwishError {
  isAvailabilityError() { return true; }
}
